import Tippy from "@tippyjs/react";
import React, { useState } from "react";
import styled from "styled-components";
import type { Placement } from "tippy.js";

interface Props {
  // https://atomiks.github.io/tippyjs/v6/all-props/#placement
  placement: Placement;
  render: (attrs: any) => React.ReactNode;
  children: any;
  offset?: [number, number];
}

export const Tooltip = ({ children, placement, render, offset = [0, 32] }: Props) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  return (
    <Tippy
      placement={placement}
      popperOptions={{
        modifiers: [
          {
            name: "arrow",
            options: {
              element: "[data-arrow]",
            },
          },
        ],
      }}
      visible={isVisible}
      duration={[0, 0]}
      offset={offset}
      render={(attrs) => isVisible && render(attrs)}
      delay={0}
    >
      <Container
        onMouseEnter={() => {
          setIsVisible(true);
        }}
        onMouseLeave={() => {
          setIsVisible(false);
        }}
      >
        {children}
      </Container>
    </Tippy>
  );
};

const Container = styled.div``;
